export default function Footer() {

    return (
        <footer>
            <span>&copy; {(new Date().getFullYear())} Johnson Music School. Created by <a target="_BLANK" href="http://www.racheljohnson.net">Rachel Johnson</a></span>
        </footer>
    )
}
